/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(['ext', 'ol', 'hvx/modules/CoreModule'], function(Ext, ol, Core){
	
	return Ext.define('map.DefaultHoverRenderer', {
		
		render: function(container, feature) {
			var titleText = feature.get('title');
			if (titleText && String(titleText).trim()) {
				container.setHtml(titleText);
				return true;
			}
			return false;
		}
	});

});
